import { Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'

import Layout from './components/layout/Layout'
import ScrollToTop from './components/layout/ScrollToTop'
import Spinner from './components/ui/Spinner'
import Home from './pages/Home'
import NotFound from './pages/NotFound'

const TanlovTartibi = lazy(() => import('./pages/TanlovTartibi'))
const Nizom = lazy(() => import('./pages/Nizom'))
const Murojaat = lazy(() => import('./pages/Murojaat'))
const Royxat = lazy(() => import('./pages/Royxat'))
const RoyxatTasdiqlash = lazy(() => import('./pages/RoyxatTasdiqlash'))
const RoyxatMuvaffaqiyat = lazy(() => import('./pages/RoyxatMuvaffaqiyat'))
const AdminLogin = lazy(() => import('./pages/admin/Login'))
const AdminDashboard = lazy(() => import('./pages/admin/Dashboard'))
const AdminContacts = lazy(() => import('./pages/admin/Contacts'))

function PageLoader() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <Spinner size={48} />
    </div>
  )
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public site (with TopBar/Footer) */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/tanlov-tartibi" element={<Suspense fallback={<PageLoader />}><TanlovTartibi /></Suspense>} />
          <Route path="/nizom" element={<Suspense fallback={<PageLoader />}><Nizom /></Suspense>} />
          <Route path="/nizom/qoidalar" element={<Suspense fallback={<PageLoader />}><Nizom /></Suspense>} />
          <Route path="/nizom/murojaat" element={<Suspense fallback={<PageLoader />}><Nizom /></Suspense>} />
          <Route path="/murojaat" element={<Suspense fallback={<PageLoader />}><Murojaat /></Suspense>} />
          <Route path="/royxatdan-otish" element={<Suspense fallback={<PageLoader />}><Royxat /></Suspense>} />
          <Route path="/royxatdan-otish/tasdiqlash" element={<Suspense fallback={<PageLoader />}><RoyxatTasdiqlash /></Suspense>} />
          <Route path="/royxatdan-otish/muvaffaqiyat" element={<Suspense fallback={<PageLoader />}><RoyxatMuvaffaqiyat /></Suspense>} />
        </Route>

        {/* Admin (no public TopBar/Footer — has own AdminHeader) */}
        <Route path="/admin/login" element={<Suspense fallback={<PageLoader />}><AdminLogin /></Suspense>} />
        <Route path="/admin" element={<Suspense fallback={<PageLoader />}><AdminDashboard /></Suspense>} />
        <Route path="/admin/contacts" element={<Suspense fallback={<PageLoader />}><AdminContacts /></Suspense>} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}
